import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { avatarBaseUrl, sitename, url } from '../../../config';
import { buildAvatarPath } from '../../../helpers/photoutils';
import { militaryToNot } from '../../../helpers/timeFormatHelpers';

class BookingConfirmationHost extends React.Component {
  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      threadId: PropTypes.number.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      guestName: PropTypes.string.isRequired,
      guestLastName: PropTypes.string.isRequired,
      guestProfilePic: PropTypes.string.isRequired,
      guestJoinedDate: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      allowedCheckInTime: PropTypes.string.isRequired,
      allowedCheckOutTime: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      padding: '10px',
      textAlign: 'center',
    };

    const buttonStyle = {
      margin: 0,
      fontFamily: 'Proxima Nova',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'bold',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#35BAEF',
      backgroundColor: '#35BAEF',
      color: '#ffffff',
      borderTopWidth: '1px',
    };

    const bookingTitle = {
      paddingBottom: '25px',
      fontWeight: 'bold',
      fontSize: '40px',
      lineHeight: '48px',
      margin: '0',
      padding: '0',
      textAlign: 'center',
    };

    const profilePic = {
      borderRadius: '999px',
      margin: '0',
      padding: '0',
      lineHeight: '150%',
      borderSpacing: '0',
      width: '125px',
    };

    const userName = {
      color: '#565a5c',
      fontSize: '26px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    };

    const subTitle = {
      color: '#565a5c',
      fontSize: '18px',
      fontWeight: 'bold',
      paddingBottom: '5px',
    };

    const space = {
      paddingBottom: '20px',
    };
    const {
      content: { threadId },
    } = this.props;
    const {
      content: {
        guestName,
        guestLastName,
        guestProfilePic,
        guestJoinedDate,
        listTitle,
      },
    } = this.props;
    const {
      content: {
        pickupTime,
        returnTime,
        pickupDate,
        returnDate,
        allowedCheckInTime,
        allowedCheckOutTime,
        confirmationCode,
      },
    } = this.props;
    let checkInDate =
      pickupDate != null
        ? moment.utc(pickupDate).format('ddd, Do MMM, YYYY') +
          ' ' +
          militaryToNot(pickupTime)
        : '';
    let checkOutDate =
      returnDate != null
        ? moment.utc(returnDate).format('ddd, Do MMM, YYYY') +
          ' ' +
          militaryToNot(returnTime)
        : '';
    let checkInDateShort =
      pickupDate != null
        ? moment.utc(pickupDate).format('Do MMM') +
          ' ' +
          militaryToNot(pickupTime)
        : '';
    let guestJoinedYear =
      guestJoinedDate != null ? moment(guestJoinedDate).format('YYYY') : '';
    let messageURL = url + '/inbox/' + threadId;
    let imageURL;
    if (guestProfilePic) {
      imageURL = buildAvatarPath(guestProfilePic, '/medium_');
    }

    return (
      <Layout>
        <Header color="#159CE9" backgroundColor="#F7F7F7" />
        <div>
          <Table width="100%">
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <h1 style={bookingTitle}>
                    New reservation confirmed! <br />
                    <span>
                      {guestName} is renting your {listTitle}
                    </span>{' '}
                    <br />
                    <span>Pickup: {checkInDateShort}</span>
                  </h1>
                  <EmptySpace height={20} />
                  <div>
                    Payment has been successfully process from the guest and will be held until the reservation is completed successfully. 
                    See reservation details in the inbox, and message{' '}
                    {guestName} to confirm details.
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    {guestProfilePic && (
                      <img style={profilePic} src={imageURL} height={125} />
                    )}
                  </div>
                  <EmptySpace height={20} />
                  <div>
                    <span style={userName}>
                      {guestName} {guestLastName}
                    </span>
                    <br />
                    <EmptySpace height={5} />
                    <span>
                      {sitename} member since {guestJoinedYear}
                    </span>
                  </div>
                  <EmptySpace height={30} />
                  <div>
                    <a href={messageURL} style={buttonStyle}>
                      Contact Guest
                    </a>
                  </div>
                  <EmptySpace height={40} />
                </TD>
              </TR>
            </TBody>
          </Table>
          <Table width="100%">
            <TBody>
              <TR style={textStyle}>
                <TD style={space}>
                  <span style={subTitle}>Pickup</span>
                  <br />
                  <EmptySpace height={10} />
                  <span>{checkInDate}</span>
                  <br />
                  <EmptySpace height={1} />
                  <span>{allowedCheckInTime}</span>
                </TD>
                <TD style={space}>
                  <EmptySpace height={10} />
                </TD>
                <TD style={space}>
                  <span style={subTitle}>Drop Off</span>
                  <br />
                  <EmptySpace height={10} />
                  <span>{checkOutDate}</span>
                  <br />
                  <EmptySpace height={1} />
                  <span>{allowedCheckOutTime}</span>
                </TD>
              </TR>
              <TR style={textStyle}>
                <TD>
                  <div>
                    <span style={subTitle}>Confirmation Code</span>
                    <br />
                    <EmptySpace height={10} />
                    <span>{confirmationCode}</span>
                    <EmptySpace height={10} />
                  </div>
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={50} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default BookingConfirmationHost;



// WEBPACK FOOTER //
// ./src/core/email/template/BookingConfirmationHost.js